export enum BusinessType {
  HONEY = "Miel",
  MILK = "Lácteos",
  TRAILS = "Senderos",
  SODA = "Soda",
  COFFE = "Cafe",
  TOUR = "Tour",
  BAKERY = "Panadería",
}

export interface ProductPresentation {
  weight?: string;
  flavor?: string;
  price: string;
}

export interface BaseProduct {
  id: string;
  image: string | string[];
  price?: string;
  presentations?: ProductPresentation[];
}

export interface Product extends BaseProduct {
  name: string;
  description: string;
}

export interface BaseVideo {
  id: string;
  url: string;
  thumbnail?: string;
}

export interface Video extends BaseVideo {
  name: string;
  description?: string;
}

export interface ContactInfo {
  email: string;
  phone: string;
  address: string;
}

export interface SocialMedia {
  facebook?: string;
  instagram?: string;
  tiktok?: string;
  twitter?: string;
  whatsapp?: string;
  website?: string;
}

export interface BaseImage {
  id: string;
  url: string;
  name?: string;
}

export interface ImageItem extends BaseImage {
  name: string;
}

export interface BaseTour {
  id: string;
  price: string;
  image: string | string[];
  duration?: string;
}

export interface Tour extends BaseTour {
  name: string;
  description: string;
  status?: string;
}

export interface BaseBusiness {
  id: string;
  logo: string;
  location?: { lat: number; lng: number };
  backgroundImage?: string;
  type: BusinessType;
  products: BaseProduct[];
  videos?: BaseVideo[];
  tours?: BaseTour[];
  soda?: {
    image?: string;
  };
  artesanias?: object;
  images: BaseImage[];
  contactInfo: ContactInfo;
  socialMedia: SocialMedia;
}

export interface Business extends BaseBusiness {
  name: string;
  shortDescription: string;
  longDescription: string;
  products: Product[];
  videos?: Video[];
  tours?: Tour[];
  soda?: {
    description: string;
    image?: string;
  };
  artesanias?: {
    description: string;
    status?: string;
  };
  images: ImageItem[];
}

export interface Association {
  name: string;
  logo: string;
  slogan: string;
  description: string;
  history: string;
  mission: string;
  vision: string;
  contactInfo: ContactInfo;
  socialMedia: SocialMedia;
  galleryImages: string[];
}
